import { SVGComponentProps } from "./utils/Types"

const TableIcon = ({ width = 24, height = 24, className }: SVGComponentProps) => {
    return (
        <svg
            className={`text-current ${className}`}
            width={width}
            height={height}
            viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M8.21057 3.94752H21.0395V5.9212H8.21057V3.94752ZM4.75663 6.41462C3.9391 6.41462 3.27637 5.75189 3.27637 4.93436C3.27637 4.11683 3.9391 3.4541 4.75663 3.4541C5.57416 3.4541 6.23689 4.11683 6.23689 4.93436C6.23689 5.75189 5.57416 6.41462 4.75663 6.41462ZM4.75663 13.3225C3.9391 13.3225 3.27637 12.6597 3.27637 11.8422C3.27637 11.0247 3.9391 10.362 4.75663 10.362C5.57416 10.362 6.23689 11.0247 6.23689 11.8422C6.23689 12.6597 5.57416 13.3225 4.75663 13.3225ZM4.75663 20.1317C3.9391 20.1317 3.27637 19.4689 3.27637 18.6514C3.27637 17.8339 3.9391 17.1712 4.75663 17.1712C5.57416 17.1712 6.23689 17.8339 6.23689 18.6514C6.23689 19.4689 5.57416 20.1317 4.75663 20.1317ZM8.21057 10.8554H21.0395V12.8291H8.21057V10.8554ZM8.21057 17.7633H21.0395V19.737H8.21057V17.7633Z"
            />
        </svg>
    )
}

export default TableIcon
